<template>
  <div>
    <div v-if="post.content" class="item-content">{{ post.content }}</div>
    <div v-else-if="postHasMedia">
      <div v-if="postAttachmentFilename" class="item-content">{{ postAttachmentFilename }}</div>
      <div v-else>{{ $translate("PostListItemContent.mediaPost") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    postAttachmentFilename() {
      return this.post.attachments[0]?.filename
    },
    postHasMedia() {
      //Remove attachments? check when backend is fixed, here and in the template
      return this.post.images.length || this.post.gifs.length || this.post.videos.length || this.post.attachments?.length
    }
  }
}
</script>
